import { render, staticRenderFns } from "./APIConfigSettings.vue?vue&type=template&id=09cc14da&"
import script from "./APIConfigSettings.vue?vue&type=script&lang=js&"
export * from "./APIConfigSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports